var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: {
                  title: _vm.user.firstName + " " + _vm.user.lastName,
                  icon: "ti-user"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c("business-card", {
                staticClass: "rounded-0 h-100",
                attrs: {
                  name: _vm.name,
                  contractNumber: _vm.user.contractNumber,
                  email: _vm.user.email,
                  roles: _vm.roles,
                  userTitle: _vm.user.title,
                  createdAt: _vm.user.createdAt,
                  dateOfBirth: _vm.user.dateOfBirth,
                  dateOfDeath: _vm.user.dateOfDeath,
                  showIcon: !!_vm.user.dateOfDeath,
                  imageSrc: _vm.user.avatarUuid
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", [_c("admin-user-status")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.contractCategories, function(category) {
        return _vm.getContractsByCategory(category.value).length > 0
          ? _c(
              "b-row",
              { key: category.value, staticClass: "mt-2" },
              [
                _c(
                  "b-col",
                  [
                    _c("AdminContractsCard", {
                      attrs: {
                        collapseId: category.value + "Id",
                        title: category.text,
                        items: _vm.getContractsByCategory(category.value),
                        phView: false
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c("admin-user-address"),
      _vm._v(" "),
      _c("admin-user-contact-person"),
      _vm._v(" "),
      _c("admin-user-invitation"),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [_c("b-col", [_c("admin-user-documents")], 1)],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-308c672a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-308c672a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUserDetail.vue
// module id = +m+J
// module chunks = 1